export const validateTimeRange = (startTime: string, endTime: string): boolean => {
  // Handle empty values
  if (!startTime || !endTime) return false;

  // Convert time strings to comparable values (minutes since midnight)
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);
  
  // Validate input values
  if (isNaN(startHour) || isNaN(startMinute) || isNaN(endHour) || isNaN(endMinute)) {
    return false;
  }
  
  if (startHour < 0 || startHour > 23 || endHour < 0 || endHour > 23) {
    return false;
  }
  
  if (startMinute < 0 || startMinute > 59 || endMinute < 0 || endMinute > 59) {
    return false;
  }
  
  const startMinutes = startHour * 60 + startMinute;
  const endMinutes = endHour * 60 + endMinute;
  
  // Ensure end time is after start time
  return endMinutes > startMinutes;
};

export const getMinEndTime = (startTime: string): string => {
  if (!startTime) return '';
  
  const [hours, minutes] = startTime.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) return '';
  
  const totalMinutes = hours * 60 + minutes + 30; // Add minimum 30 minutes
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;
  
  return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}; 